import Navigator from 'app';
import NavbarController from './navbar_controller';
const API = {
  showNavbar: function () {
    NavbarController.showNavbar();
  }
};
Navigator.on("start", function () {
  API.showNavbar();
});
Navigator.vent.on("navbar:show", function () {
  API.showNavbar();
});